/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.initProfileForm = function() {
  if ($('form.new_account_user_profile').length) {
    if ($('input[name="account_user_profile[owner_resident]"]:checked').val() === "visitor") {
      $("#resident-info").hide();
    } else {
      $("#visitor-info").hide();
    }
    return $('input[name="account_user_profile[owner_resident]"]').change(function() {
      if ((this.value === "owner") || (this.value === "renter")) {
        $("#resident-info").show();
        $("#visitor-info").hide();
      }
      if (this.value === "visitor") {
        $("#resident-info").hide();
        return $("#visitor-info").show();
      }
    });
  }
};
        
/*
$(() => initProfileForm());
*/

function initProfileFormOnLoad() {
  if ($('form.new_account_user_profile').length) {
    initProfileForm();
  }
}

$(initProfileFormOnLoad);
document.addEventListener('turbo:load', initProfileFormOnLoad);
